import { Marker, Popup } from 'react-leaflet'
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import VideoPlayer from '../VideoPlayer/VideoPlayer'
import { useEffect, useRef, useState } from 'react'
import movieIcon from '../../assets/movie-camera.svg'
import { TWS_API_URL } from '../../environment/apis.config'
import { getAccessToken } from '../../utils/auth.util'
import { Link } from 'react-router-dom'

const FORT_WORTH: [number, number] = [32.865305, -96.668788]

export default function CameraPopup() {
  const [signedUrl, setSignedUrl] = useState<string>('')
  const markerRef = useRef<L.Marker | null>(null)

  const cameraMarkerIcon = new L.Icon({
    iconUrl: movieIcon,
    iconSize: [36, 36], // adjust based on your SVG
    iconAnchor: [18, 36], // point of the icon which corresponds to marker location
    popupAnchor: [0, -36], // popup opens above the icon
  })

  const getSignedUrl = async () => {
    const token = await getAccessToken()
    const response = await fetch(`${TWS_API_URL}/api/video/stream`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json; charset=utf-8',
      },
    })

    const data = await response.json()
    setSignedUrl(data.url)
  }

  useEffect(() => {
    getSignedUrl()
  }, [])

  const historicalDataIcon = (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path
          d="M22 14V12C22 8.22876 22 6.34315 20.8284 5.17157C19.6569 4 17.7712 4 14 4M14 22H10C6.22876 22 4.34315 22 3.17157 20.8284C2 19.6569 2 17.7712 2 14V12C2 8.22876 2 6.34315 3.17157 5.17157C4.34315 4 6.22876 4 10 4"
          stroke="#000000"
          stroke-width="1.5"
          stroke-linecap="round"
        ></path>{' '}
        <path
          d="M7 4V2.5"
          stroke="#000000"
          stroke-width="1.5"
          stroke-linecap="round"
        ></path>{' '}
        <path
          d="M17 4V2.5"
          stroke="#000000"
          stroke-width="1.5"
          stroke-linecap="round"
        ></path>{' '}
        <circle
          cx="18"
          cy="18"
          r="3"
          stroke="#000000"
          stroke-width="1.5"
        ></circle>{' '}
        <path
          d="M20.5 20.5L22 22"
          stroke="#000000"
          stroke-width="1.5"
          stroke-linecap="round"
        ></path>{' '}
        <path
          d="M21.5 9H16.625H10.75M2 9H5.875"
          stroke="#000000"
          stroke-width="1.5"
          stroke-linecap="round"
        ></path>{' '}
      </g>
    </svg>
  )

  markerRef?.current?.on('popupopen', (e) => {
    let videoElement: HTMLVideoElement = document.getElementById(
      'video-player'
    ) as HTMLVideoElement
    if (videoElement && videoElement.paused) {
      videoElement.play()
    }
  })

  return (
    <Marker position={FORT_WORTH} ref={markerRef} icon={cameraMarkerIcon}>
      <Popup className="video-player">
        <div className="w-full h-1/2">
          <VideoPlayer src={signedUrl} />
        </div>
        <Link
          to="/ipcamera"
          className="text-underline text-blue-500 pointer-cursor"
        >
          <span>View Historical Data</span>
          <div className="h-4 w-4 inline-block">{historicalDataIcon}</div>
        </Link>
      </Popup>
    </Marker>
  )
}
